import { useRef, useState } from "react";
import FilePreviewView from "./FilePreviewView";
import FileHelper from "../../helpers/FileHelper";
import useCustomEffect from "../../hooks/useCustomEffect";

function FilePreview({
  path,
  children,
  onCloseCallback,
  onOpenCallback,
  closeable = true,
  onRead = () => {},
}) {
  const [showPreview, setShowPreview] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const disabled = typeof path !== "string" || path.includes("[object Blob]");
  const pathType = FileHelper.pathType(path);
  const containerRef = useRef(null);

  /**
   * UseEffect for calling onRead when the content is fully visible
   */
  useCustomEffect(() => {
    setTimeout(() => {
      onContainerInit();
    }, 100);
  }, [containerRef.current, showPreview, loaded]);

  /**
   * This method will handle the onOpen event
   */
  function onOpen() {
    if (disabled) {
      return;
    }
    onOpenCallback && onOpenCallback();
    setShowPreview(true);
  }

  /**
   * This method will handle the onClose event
   */
  function onClose() {
    onCloseCallback && onCloseCallback();
    setShowPreview(false);
    setLoaded(false);
  }

  /**
   * This method will check if the preview was read on init
   */
  function onContainerInit() {
    if (!containerRef.current || !loaded) return;

    if (
      (pathType === "attachment" || pathType === "image") &&
      containerRef.current.scrollHeight <= containerRef.current.clientHeight
    ) {
      onRead();
    }
  }

  /**
   * This method will check if the preview was read while scrolling
   */
  function onContainerScroll() {
    if (!containerRef.current) return;

    if (
      pathType !== "video" &&
      containerRef.current.scrollTop + containerRef.current.clientHeight >=
        containerRef.current.scrollHeight - 1
    ) {
      onRead();
    }
  }

  /**
   * This method will handle the video end event
   */
  function onVideoEnd() {
    onRead();
  }

  function onLoaded() {
    setLoaded(true);
  }

  return (
    <FilePreviewView
      path={path}
      showPreview={showPreview}
      containerRef={containerRef}
      onClose={onClose}
      onOpen={onOpen}
      disabled={disabled}
      pathType={pathType}
      onContainerScroll={onContainerScroll}
      onVideoEnd={onVideoEnd}
      onLoaded={onLoaded}
      closeable={closeable}
    >
      {children}
    </FilePreviewView>
  );
}

export default FilePreview;
